import { get, post, put } from '../actions/method';
import helper from '../utils/helper';

export async function validateLicense(params) {
  let _params = {
    body: params,
  };
  return await post(`app/license/validate`, _params);
}

export async function applyLicense(params) {
  let _params = {
    body: params,
  };
  return await post(`app/license/upload`, _params);
}

export async function checkDepartmentLicense(departmentId) {
  const params = helper.compileQueryString({ departmentId });
  return await get(`app/license/department${params}`);
}

export async function getLicenseDetail(departmentId) {
  return await get(`app/license/${departmentId}/details`);
}

export async function updateDepartmentLogo(deptId, params) {
  let _params = {
    body: params,
  };
  return await put(`app/departments/${deptId}/logo`, _params);
}

export async function getDepartmentLogo(deptId) {
  return await get(`app/departments/${deptId}/logo`);
}

export async function sendLicenseEmail() {
  return await post('app/license/report/send');
}
